import React from 'react';
import { Users } from 'lucide-react';

/**
 * Circular avatar + online dot + unread badge. Extracted from the collapsed
 * rail pattern already used in ConversationList.jsx (kept unmodified there —
 * this is an additive, presentational-only component reused by the Mini
 * Chat Dock).
 */
const ConversationAvatar = ({
  conv,
  size = 46,
  employeeProfilePics = {},
  getAvatarColor,
  isOnline = false,
  unreadCount = 0,
  c,
  active = false,
}) => {
  const pic = employeeProfilePics[conv.id];
  const isGroup = conv.isGroup || String(conv.id).startsWith('group-');
  const dotSize = Math.max(10, Math.round(size * 0.26));
  const badgeMinSize = Math.max(16, Math.round(size * 0.4));

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {pic ? (
        <img
          src={pic}
          alt={conv.name}
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            objectFit: 'cover',
            border: active ? '2px solid #2e7cba' : `2px solid ${c.border}`,
            boxSizing: 'border-box',
            display: 'block',
          }}
          onError={(e) => {
            e.target.style.display = 'none';
            if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          display: pic ? 'none' : 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: '700',
          fontSize: Math.round(size * 0.32),
          background: getAvatarColor(conv.name),
          border: active ? '2px solid #2e7cba' : '2px solid transparent',
          boxSizing: 'border-box',
        }}
      >
        {isGroup ? <Users size={Math.round(size * 0.4)} /> : conv.avatar}
      </div>

      {isOnline && (
        <div
          style={{
            position: 'absolute',
            bottom: '1px',
            right: '1px',
            width: dotSize,
            height: dotSize,
            background: c.online || '#22c55e',
            border: `2px solid ${c.sidebarBg}`,
            borderRadius: '50%',
          }}
        />
      )}

      {unreadCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            minWidth: badgeMinSize,
            height: badgeMinSize,
            background: '#2563eb',
            color: '#fff',
            fontSize: '10px',
            borderRadius: '9px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            padding: '0 4px',
            boxSizing: 'border-box',
          }}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
};

export default ConversationAvatar;
